import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
export function MobileStickyCta({
  label,
  onClick
}: {
  label: string;
  onClick: () => void;
}) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 520);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-130" data-mp="mgvpklakaib2">
      {visible && <motion.div initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-brand-line bg-white px-4 py-3 md:hidden" data-id="element-131" data-mp="mfube7y91fp4">
          <button type="button" onClick={onClick} className="w-full rounded-sm bg-brand-red py-3 text-sm font-semibold text-white" data-id="element-132" data-mp="109v70stwmml9">
            {label}
          </button>
        </motion.div>}
    </AnimatePresence>;
}